import React from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import ClientsTemplate from '@components/Clients/Clients';
import CompanyValuesTemplate from '@components/CompanyValues/CompanyValues';
import FaqsTemplate from '@components/Faqs/Faqs';
import FooterTemplate from '@components/Footer/Footer';
import GalleryTemplate from '@components/Gallery/Gallery';
import HeaderTemplate from '@components/Header/Header';
import useTranslation from '@hooks/useTranslation';
import DividerTemplate from '@ui/Divider/Divider';
import HeroTemplate from '@ui/Hero/Hero';
import { publicAssets } from '@utils/url.utils';
import { IS_PROD } from '../constants';

interface IAboutUs {}

const AboutUs: NextPage<IAboutUs> = () => {
    const { t } = useTranslation();

    return (
        <>
            <NextSeo
                title={t('seo.about.title')}
                description={t('seo.about.description')}
                noindex={!IS_PROD}
                nofollow={!IS_PROD}
                openGraph={{
                    images: [{ url: `https://profivzdelavanie.sk${publicAssets('/og-konferencia.png')}` }],
                }}
            />
            <HeaderTemplate />
            <HeroTemplate
                titleKey="about.hero.title"
                imageKey="about_hero.webp"
                descriptionKey="about.hero.paragraph"
                withBenefits
            />
            <DividerTemplate marginBottom={20} />
            <CompanyValuesTemplate />
            <DividerTemplate marginBottom={20} />
            <FaqsTemplate />
            <GalleryTemplate />
            <ClientsTemplate titleKey={'about.clients.title'} />
            <FooterTemplate />
        </>
    );
};

export default AboutUs;
